import React, { useEffect } from 'react';
import { useAppStore } from '../../store/useAppStore';
import { AlertCircle, CheckCircle, Info, X } from 'lucide-react';
import './Toast.css';

export const Toast: React.FC = () => {
  const toast = useAppStore(state => state.toast);
  const setToast = useAppStore(state => state.setToast);

  useEffect(() => {
    if (!toast) return;
    const timer = setTimeout(() => {
      setToast(null);
    }, 4000);
    return () => { clearTimeout(timer); };
  }, [toast, setToast]);

  if (!toast) return null;

  const Icon = toast.type === 'error' ? AlertCircle : toast.type === 'success' ? CheckCircle : Info;

  return (
    <div className={`global-toast toast-${toast.type}`} role="alert">
      <Icon size={18} className="toast-icon" />
      <span className="toast-message">{toast.message}</span>
      <button 
        className="toast-close" 
        onClick={() => { setToast(null); }}
        aria-label="Close notification"
      >
        <X size={16} />
      </button>
    </div>
  );
};
